"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var uniqueId_1 = __importDefault(require("../../util/uniqueId"));
var ClotheColor_1 = __importDefault(require("./ClotheColor"));
function Overall() {
    var path1 = react_1.useMemo(function () { return uniqueId_1.default('react-path-'); }, []);
    var mask1 = react_1.useMemo(function () { return uniqueId_1.default('react-mask-'); }, []);
    return (jsx_runtime_1.jsxs("g", __assign({ transform: 'translate(0.000000, 170.000000)' }, { children: [jsx_runtime_1.jsx("defs", { children: jsx_runtime_1.jsx("path", { id: path1, d: 'M94,29.6883435 L94,74 L170,74 L170,29.6883435 C179.362956,30.9893126 188.149952,34.0907916 196.00002,38.6318143 L196,110 L187,110 L77,110 L68,110 L68,38.6318027 C75.8500482,34.0907916 84.6370437,30.9893126 94,29.6883435 Z' }, void 0) }, void 0),
            jsx_runtime_1.jsx("mask", __assign({ id: mask1, fill: 'white' }, { children: jsx_runtime_1.jsx("use", { xlinkHref: '#' + path1 }, void 0) }), void 0),
            jsx_runtime_1.jsx("use", { fill: '#B7C1DB', fillRule: 'evenodd', xlinkHref: '#' + path1 }, void 0),
            jsx_runtime_1.jsx(ClotheColor_1.default, { maskID: mask1 }, void 0),
            jsx_runtime_1.jsx("circle", { fill: '#F4F4F4', fillRule: 'evenodd', cx: '81', cy: '83', r: '5' }, void 0),
            jsx_runtime_1.jsx("circle", { fill: '#F4F4F4', fillRule: 'evenodd', cx: '183', cy: '83', r: '5' }, void 0)] }), void 0));
}
exports.default = Overall;
